import { render, staticRenderFns } from "./Mantenimientos.vue?vue&type=template&id=6730c026&"
import script from "./Mantenimientos.vue?vue&type=script&lang=js&"
export * from "./Mantenimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports